// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-form.section[data-v-330ad225] {\n  padding: 10px 20px 20px 20px;\n}\n.contact-form .el-select[data-v-330ad225] {\n  width: 100%;\n}\n.contact-form .no-pointer[data-v-330ad225]  .el-checkbox__input {\n  cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
